import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NomenclatureComplexPartModel } from '@medindex-webapi';
import { HelixRoutes } from '@shared/enums/routes';
import { YmGoalCatalogItem } from '../../enums/ym-goal-catalog-item.enum';

@Component({
  selector: 'app-complex-parts',
  templateUrl: './complex-parts.component.html',
  styleUrls: ['./complex-parts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplexPartsComponent {
  @Input() parts: NomenclatureComplexPartModel[] = [];

  protected readonly HelixRoutes = HelixRoutes;
  protected readonly YmGoalCatalogItem = YmGoalCatalogItem;

  getLink(hxid: string): string {
    return `/${HelixRoutes.CatalogItem}/${hxid}`;
  }
}
